/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterNotificationRuleMonitorScopeConditionDto } from './PublicFilterNotificationRuleMonitorScopeConditionDto';
import type { PublicSeverity } from './PublicSeverity';

export type PublicSeverityFilterNotificationRuleMonitorScopeConditionDto = (PublicFilterNotificationRuleMonitorScopeConditionDto & {
    /**
     * Operator of the condition
     */
    operator?: PublicSeverityFilterNotificationRuleMonitorScopeConditionDto.operator;
    /**
     * Monitor severities to filter on. Supported values: CRITICAL, HIGH, MODERATE, LOW.
     */
    severities?: Array<PublicSeverity>;
} & {
    /**
     * Operator of the condition
     */
    operator: PublicSeverityFilterNotificationRuleMonitorScopeConditionDto.operator;
    /**
     * Monitor severities to filter on. Supported values: CRITICAL, HIGH, MODERATE, LOW.
     */
    severities: Array<PublicSeverity>;
});

export namespace PublicSeverityFilterNotificationRuleMonitorScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
